import { createContext, useContext, type ReactNode } from 'react';
import { AdminApiClient } from './api';

export interface AppContextValue {
  api: AdminApiClient;
  apiBase: string;
  setApiBase: (v: string) => void;
  adminToken: string;
  setAdminToken: (v: string) => void;
  clerkEnabled: boolean;
}

const AppContext = createContext<AppContextValue | null>(null);

export function AppProvider({ value, children }: { value: AppContextValue; children: ReactNode }) {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useAppState(): AppContextValue {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppState must be used within AppProvider');
  return ctx;
}
